export function PrivacyPolicy() {
    return (
      <h1>
        I dont collect data directly, the only data collection is made by google and their ads system
      </h1>
    );
  }